import { render, staticRenderFns } from "./AkinSoftKategori.vue?vue&type=template&id=463e4ccc&scoped=true"
import script from "./AkinSoftKategori.vue?vue&type=script&lang=js"
export * from "./AkinSoftKategori.vue?vue&type=script&lang=js"
import style0 from "./AkinSoftKategori.vue?vue&type=style&index=0&id=463e4ccc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463e4ccc",
  null
  
)

export default component.exports